module.exports = __webpack_public_path__ + "img/perforaciones_4-3.5d615979.webp";